import React from 'react';
import { Description, DescriptionText } from './Description';

export const AdditionalInfoAboutOthers = () => {
  return (
    <Description type='primary'>
      <DescriptionText textSize='small'>
        安全書類に正しく出力されない可能性があります。各入力項目の組み合わせを再確認頂きますようお願いします。
      </DescriptionText>
    </Description>
  );
};



// WEBPACK FOOTER //
// ./src/components/AdditionalInfoAboutOthers.jsx